export default {
  rezi: true,
  cool: true,
};